import { MARKETABLE_CONTACTS_ACCESS, MARKETABLE_CONTACTS_ELIGIBILITY_FLOW_ACCESS, MARKETABLE_CONTACTS_WRITE } from 'pricing-pages-lib/constants/Scopes';
import { createSelector } from 'reselect';
import { FetchMarketingContactsRequestTypes } from '../actions/MarketingContactsActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
import { hasScopeSelector } from './ScopeSelectors';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import * as RequestStatus from '../actions/constants/RequestStatus';
import { portalHasAccessToEligibilityFlow, shouldShowEligibilityFlow } from 'pricing-pages-lib/utils/marketingContactsUtils';
import { hasProductLineSelectorInProductInventorySelector } from './ProductInventorySelectors';
export const fetchMarketingContactsStatus = makeRequestStatusSelector(FetchMarketingContactsRequestTypes.REQUEST);
export const hasMarketingContactsWriteScopeSelector = state => {
  return hasScopeSelector(state, MARKETABLE_CONTACTS_WRITE);
};
export const hasMarketingContactsEFViewAccess = state => {
  return hasScopeSelector(state, MARKETABLE_CONTACTS_ELIGIBILITY_FLOW_ACCESS);
};
export const isOnMCPlanSelector = state => {
  return hasScopeSelector(state, MARKETABLE_CONTACTS_ACCESS);
};
const ownsPaidMarketingHubSelector = state => hasProductLineSelectorInProductInventorySelector(state, {
  productLine: ProductLines.MARKETING
});
const portalHasAccessToEligibilityFlowSelector = createSelector([hasMarketingContactsWriteScopeSelector, hasMarketingContactsEFViewAccess, ownsPaidMarketingHubSelector], (hasWriteScope, hasEFScope, ownsPaidMarketingHub) => portalHasAccessToEligibilityFlow({
  hasWriteScope,
  hasEFScope,
  ownsPaidMarketingHub
}));
export const marketingContactsOnRenewalSelector = state => {
  const {
    marketingContacts
  } = state;
  const marketingContactsStatus = fetchMarketingContactsStatus(state);

  // Anyone without the write scope defaults to all contacts non-MC on purchase
  if (!portalHasAccessToEligibilityFlowSelector(state)) return 0;
  if (!marketingContacts || marketingContactsStatus === RequestStatus.FAILED) return null;

  // We need to use different CRM search calls depending on if the portal has MC or not
  if (isOnMCPlanSelector(state)) {
    // The user is on MC, so the api call uses both the marketing status
    // and the marketing until next update status
    return marketingContacts.onMCRenewal;
  }

  // The user isn't on MC, so the api call doesn't pay attention to the
  // marketing status field, just marketing until next update
  return marketingContacts.onSwitchToMC;
};
export const shouldShowEligibilityFlowSelector = createSelector([marketingContactsOnRenewalSelector, portalHasAccessToEligibilityFlowSelector], (marketingContactsOnRenewal, hasAccessToEligibilityFlow) => shouldShowEligibilityFlow({
  marketingContactsOnRenewal,
  hasAccessToEligibilityFlow
}));